import exportacaoRepository from './exportacaoRepository'
import procedimentoRepository from './procedimentoRepository'
import relatorioInconsistenciaRepository from './relatorioInconsistenciaRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/raas`

    return {
        exportacao: exportacaoRepository(baseUrl),
        procedimento: procedimentoRepository(baseUrl),
        relatorioInconsistencia: relatorioInconsistenciaRepository(baseUrl),
    }
}
